export default {
  text: 'Pregătim masa ta 🍽…',
};
